import { render } from "./LegacyShortTermPlanView.vue?vue&type=template&id=60d1a934&scoped=true"
import script from "./LegacyShortTermPlanView.vue?vue&type=script&lang=js"
export * from "./LegacyShortTermPlanView.vue?vue&type=script&lang=js"

import "./LegacyShortTermPlanView.vue?vue&type=style&index=0&id=60d1a934&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d1a934"]])

export default __exports__